import type { StyleSystemProps } from '@withjoy/joykit';
import { styled, Flex, Box } from '@withjoy/joykit';

export const StyledSearchButton = styled(Flex)``;

export const StyledLine = styled(Box)``;

const searchButtonStyles: StyleSystemProps = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: '#333333',
  width: ['215px'],
  height: 8,
  borderRadius: '20px',
  color: '#FFFFFF',
  padding: '8px 16px 8px 12px',
};

const lineStyles: StyleSystemProps = {
  borderTop: '1px solid #EBEBEB',
  width: '100px',
};

const searchChrevonStyles: StyleSystemProps = {
  marginRight: 3,
};
export const styles = {
  searchButton: searchButtonStyles,
  line: lineStyles,
  searchChrevonStyles,
};
